/**
 * Kukamonga — Bundle Offers
 *
 * Drives the /pages/ofertas section:
 *   - 3 tabs (Articulaciones, Línea Kukamonga, Nuevos Lanzamientos)
 *   - 10+1 collections: one-click adds 11 of a product (variant modal if needed)
 *   - 5+1 collection: 6-slot bundle tray, bulk-adds all 6 on checkout
 *
 * Cart integration: every add — single, modal-confirmed, and bulk — is routed
 * through the site-wide [data-btn-addToCart] handler in assets/cart-add-fix.js.
 * Single-variant 10+1 cards render a native <form> directly in Liquid (no JS).
 * Multi-variant and bulk paths inject a hidden <form data-btn-addToCart> into
 * the DOM and programmatically click it, so the same handler that powers every
 * other product card on the store opens the correct halo side cart drawer.
 *
 * The free unit is fulfilled by Shopify automatic Buy-X-Get-Y discounts
 * configured in admin per collection.
 *
 * Bundle state persists in sessionStorage so a refresh keeps progress.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'kukamonga.bundle.nuevos-lanzamientos';
  var FALLBACK = {
    'offer.tray.progress':       '{filled}/{total} — add {remaining} more to unlock your FREE item',
    'offer.tray.progress_full':  'Bundle complete! Ready to checkout.',
    'offer.error.add_failed':    'Could not add to cart. Please try again.',
    'offer.error.sold_out':      'This variant is sold out.',
    'offer.modal.confirm_qty':   'Add {qty} to cart'
  };

  var STRINGS = {};

  function loadStrings(root) {
    var node = root.querySelector('[data-kbo-strings]');
    if (!node) return;
    try {
      var obj = JSON.parse(node.textContent || '{}');
      Object.keys(obj).forEach(function (k) { STRINGS[k] = obj[k]; });
    } catch (e) {}
  }

  function t(key, vars) {
    var tpl = STRINGS[key] || FALLBACK[key] || key;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        tpl = tpl.replace(new RegExp('\\{' + k + '\\}', 'g'), vars[k]);
      });
    }
    return tpl;
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-kbo]').forEach(initSection);
  });

  function initSection(root) {
    loadStrings(root);
    var tabs        = root.querySelectorAll('[data-kbo-tab]');
    var panels      = root.querySelectorAll('[data-kbo-panel]');
    var modal       = root.querySelector('[data-kbo-modal]');
    var tray        = root.querySelector('[data-kbo-tray]');
    var traySlots   = tray ? tray.querySelectorAll('[data-kbo-slot]') : [];
    var trayProg    = tray ? tray.querySelector('[data-kbo-tray-progress]') : null;
    var trayCheckout= tray ? tray.querySelector('[data-kbo-tray-checkout]') : null;
    var trayClear   = tray ? tray.querySelector('[data-kbo-tray-clear]') : null;
    var trayError   = tray ? tray.querySelector('[data-kbo-tray-error]') : null;

    var modalThumb  = modal ? modal.querySelector('[data-kbo-modal-thumb]') : null;
    var modalBadge  = modal ? modal.querySelector('[data-kbo-modal-badge]') : null;
    var modalTitle  = modal ? modal.querySelector('[data-kbo-modal-title]') : null;
    var modalVars   = modal ? modal.querySelector('[data-kbo-modal-variants]') : null;
    var modalConfirm= modal ? modal.querySelector('[data-kbo-modal-confirm]') : null;
    var modalConfirmLbl = modal ? modal.querySelector('[data-kbo-modal-confirm-label]') : null;
    var modalError  = modal ? modal.querySelector('[data-kbo-modal-error]') : null;

    // ----- state -----
    var activeTab = tabs.length ? (tabs[0].dataset.kboTab || 'a') : 'a';
    var bundle = loadBundle();
    var modalCtx = null; // { card, variants, qty, mode: 'add-cart' | 'add-bundle' }

    // ----- tab handlers -----
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(tab.dataset.kboTab);
      });
    });

    function switchTab(letter) {
      activeTab = letter;
      tabs.forEach(function (t) {
        var on = t.dataset.kboTab === letter;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.dataset.kboPanel === letter;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      updateTrayVisibility();
      document.dispatchEvent(new CustomEvent('kbo:tab-change', { detail: { tab: letter } }));
    }

    function activePanel() {
      var p = root.querySelector('[data-kbo-panel].is-active');
      return p || panels[0];
    }

    function isComboTab() {
      var p = activePanel();
      return p && p.dataset.offerType === '5plus1';
    }

    function updateTrayVisibility() {
      if (!tray) return;
      var show = isComboTab();
      if (show) {
        tray.removeAttribute('hidden');
        // give the browser a frame so the slide-in transform animates
        requestAnimationFrame(function () { tray.classList.add('is-open'); });
      } else {
        tray.classList.remove('is-open');
        // wait for the transition to finish before hiding
        setTimeout(function () {
          if (!isComboTab()) tray.setAttribute('hidden', '');
        }, 420);
      }
      renderTray();
    }

    // ----- card clicks -----
    root.querySelectorAll('[data-kbo-card]').forEach(function (card) {
      var cta = card.querySelector('[data-kbo-action]');
      if (!cta) return;
      cta.addEventListener('click', function () {
        var action = cta.dataset.kboAction;
        if (action === 'add-eleven')    return handleAddEleven(card, cta);
        if (action === 'add-to-bundle') return handleAddToBundle(card, cta);
      });
    });

    function parseVariants(card) {
      try {
        return JSON.parse(card.dataset.variants || '[]');
      } catch (e) {
        return [];
      }
    }

    function availableVariants(variants, requiredQty) {
      return variants.filter(function (v) {
        if (!v.available) return false;
        if (v.policy === 'continue') return true; // continue selling when out of stock
        return v.inv >= requiredQty;
      });
    }

    // ----- 10+1: add 11 of same product -----
    //
    // NOTE: Single-variant 10+1 cards render a native <form data-btn-addToCart>
    // directly in Liquid — cart-add-fix.js handles those without any JS here.
    // This handler only fires for multi-variant cards (which need the modal).
    function handleAddEleven(card, cta) {
      var variants = parseVariants(card);
      var bundleSize = parseInt(card.dataset.bundleSize, 10) || 10;
      var qty = bundleSize + 1;
      var eligible = availableVariants(variants, qty);

      if (eligible.length === 0) {
        flashCardError(cta, t('offer.error.sold_out'));
        return;
      }
      openModal({
        card: card,
        variants: variants,
        qty: qty,
        mode: 'add-cart'
      });
    }

    /**
     * Add items to cart via the theme's own [data-btn-addToCart] handler
     * in assets/cart-add-fix.js. This is the *only* path that opens the
     * correct halo side cart drawer used everywhere else on the site.
     *
     * Uses the static <form data-kbo-add-form> rendered by Liquid in the
     * section markup. We populate its hidden inputs and trigger a click on
     * its submit button. Because the form and button are in the original
     * DOM (rendered by Shopify, not dynamically injected by JS), the
     * delegated event handler in cart-add-fix.js — which is bound on
     * window.load to [data-btn-addtocart] — reliably matches the click.
     *
     * items: [{id: variantId, quantity: N}, ...]  (1 or more)
     * opts.onSuccess(cart): called after cart-add-fix.js dispatches `cart-update`.
     * opts.onError():       called only on the 8s safety timeout.
     */
    function submitViaCartHandler(items, opts) {
      opts = opts || {};
      if (!items || !items.length) return;

      var form = root.querySelector('[data-kbo-add-form]');
      var inputsHost = form && form.querySelector('[data-kbo-add-form-inputs]');
      var trigger = form && form.querySelector('[data-kbo-add-form-trigger]');
      if (!form || !inputsHost || !trigger) {
        if (opts.onError) opts.onError();
        return;
      }

      // Rebuild hidden inputs for this request.
      inputsHost.innerHTML = '';
      if (items.length === 1) {
        appendHidden(inputsHost, 'id', items[0].id);
        appendHidden(inputsHost, 'quantity', items[0].quantity);
      } else {
        // Shopify's /cart/add accepts items[N][id]/items[N][quantity] as
        // form-encoded bulk; cart-add-fix.js posts $form.serialize() so this
        // becomes one atomic bulk add.
        items.forEach(function (it, idx) {
          appendHidden(inputsHost, 'items[' + idx + '][id]', it.id);
          appendHidden(inputsHost, 'items[' + idx + '][quantity]', it.quantity);
        });
      }

      // The cart-add-fix.js guard `if ($button.hasClass('is-loading')) return;`
      // would bail if a previous request left this on the trigger. Reset it.
      trigger.classList.remove('is-loading');

      // Listen for cart-update — dispatched by cart-add-fix.js on success.
      var settled = false;
      var onCartUpdate = function (e) {
        if (settled) return;
        settled = true;
        document.removeEventListener('cart-update', onCartUpdate);
        clearTimeout(timeoutId);
        if (opts.onSuccess) opts.onSuccess(e.detail);
      };
      document.addEventListener('cart-update', onCartUpdate);

      // Timeout safety net — cart-add-fix.js handles real errors via its own
      // showWarning() toast; we only need to release our own loading state.
      var timeoutId = setTimeout(function () {
        if (settled) return;
        settled = true;
        document.removeEventListener('cart-update', onCartUpdate);
        if (opts.onError) opts.onError();
      }, 8000);

      // Use setTimeout(0) so any modal/state updates from the calling code
      // flush to the DOM before the cart-add-fix.js handler reads the form.
      setTimeout(function () { trigger.click(); }, 0);
    }

    function appendHidden(host, name, value) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = name;
      i.value = value;
      host.appendChild(i);
    }

    // ----- 5+1: bundle builder -----
    function handleAddToBundle(card, cta) {
      if (bundle.length >= 6) return; // full

      var variants = parseVariants(card);
      var eligible = availableVariants(variants, 1);
      if (eligible.length === 0) {
        flashCardError(cta, t('offer.error.sold_out'));
        return;
      }
      if (variants.length === 1 && eligible.length === 1) {
        pushToBundle(buildBundleEntry(card, eligible[0]));
        flashBundleAdded(cta);
        return;
      }
      openModal({
        card: card,
        variants: variants,
        qty: 1,
        mode: 'add-bundle'
      });
    }

    function buildBundleEntry(card, variant) {
      return {
        variantId: variant.id,
        productId: card.dataset.productId,
        title: card.dataset.productTitle,
        image: variant.image || card.dataset.productImage,
        price: variant.price,
        variantTitle: variant.title
      };
    }

    function pushToBundle(entry) {
      bundle.push(entry);
      saveBundle();
      renderTray();
      document.dispatchEvent(new CustomEvent('kbo:bundle-update', { detail: { bundle: bundle } }));
    }

    function removeFromBundle(idx) {
      bundle.splice(idx, 1);
      saveBundle();
      renderTray();
      document.dispatchEvent(new CustomEvent('kbo:bundle-update', { detail: { bundle: bundle } }));
    }

    function flashBundleAdded(cta) {
      if (!cta) return;
      cta.classList.add('is-in-bundle');
      setTimeout(function () { cta.classList.remove('is-in-bundle'); }, 900);
    }

    function flashCardError(btn, msg) {
      if (!btn) return;
      var original = btn.dataset.kboOriginalLabel;
      var label = btn.querySelector('.kbo__cta-label');
      if (label) {
        if (!original) btn.dataset.kboOriginalLabel = label.textContent;
        label.textContent = msg;
        setTimeout(function () {
          if (btn.dataset.kboOriginalLabel) label.textContent = btn.dataset.kboOriginalLabel;
        }, 2400);
      }
    }

    function renderTray() {
      if (!tray) return;
      // total = 5 paid + 1 free
      var capacity = 6;
      traySlots.forEach(function (slot, idx) {
        // clean existing fill content (preserve free-label for slot 5)
        var img = slot.querySelector('img');
        var remove = slot.querySelector('.kbo-tray__slot-remove');
        if (img) img.remove();
        if (remove) remove.remove();
        slot.classList.remove('is-filled');

        if (idx < bundle.length) {
          slot.classList.add('is-filled');
          var item = bundle[idx];
          var i = document.createElement('img');
          i.src = item.image || '';
          i.alt = item.title || '';
          slot.appendChild(i);
          // remove button (only for non-free slots — free slot is auto-assigned)
          var x = document.createElement('button');
          x.type = 'button';
          x.className = 'kbo-tray__slot-remove';
          x.setAttribute('aria-label', 'Remove');
          x.textContent = '×';
          x.addEventListener('click', function (e) {
            e.stopPropagation();
            removeFromBundle(idx);
          });
          slot.appendChild(x);
        }
      });

      // progress text
      var filled = bundle.length;
      var remaining = Math.max(0, capacity - filled);
      if (trayProg) {
        if (remaining === 0) {
          trayProg.innerHTML = '<strong>' + t('offer.tray.progress_full') + '</strong>';
        } else {
          trayProg.innerHTML = t('offer.tray.progress', {
            filled: filled,
            total: capacity,
            remaining: remaining
          });
        }
      }

      // checkout enabled at full
      if (trayCheckout) {
        trayCheckout.disabled = (filled !== capacity);
      }
      if (trayClear) {
        if (filled > 0) trayClear.removeAttribute('hidden');
        else trayClear.setAttribute('hidden', '');
      }
    }

    if (trayCheckout) {
      trayCheckout.addEventListener('click', checkoutBundle);
    }
    if (trayClear) {
      trayClear.addEventListener('click', function () {
        clearBundle();
      });
    }

    function checkoutBundle() {
      if (bundle.length !== 6 || !trayCheckout) return;
      trayCheckout.classList.add('is-loading');
      trayCheckout.disabled = true;
      hideTrayError();

      var items = bundle.map(function (b) {
        return { id: b.variantId, quantity: 1 };
      });

      submitViaCartHandler(items, {
        onSuccess: function (cart) {
          clearBundle();
          document.dispatchEvent(new CustomEvent('kbo:add-success', { detail: cart }));
          trayCheckout.classList.remove('is-loading');
        },
        onError: function () {
          showTrayError(t('offer.error.add_failed'));
          trayCheckout.classList.remove('is-loading');
          trayCheckout.disabled = (bundle.length !== 6);
        }
      });
    }

    function showTrayError(msg) {
      if (!trayError) return;
      trayError.textContent = msg;
      trayError.removeAttribute('hidden');
    }
    function hideTrayError() {
      if (!trayError) return;
      trayError.setAttribute('hidden', '');
      trayError.textContent = '';
    }

    // ----- modal -----
    function openModal(ctx) {
      if (!modal) return;
      modalCtx = ctx;
      hideModalError();

      // populate header
      if (modalThumb) modalThumb.src = ctx.card.dataset.productImage || '';
      if (modalThumb) modalThumb.alt = ctx.card.dataset.productTitle || '';
      if (modalTitle) modalTitle.textContent = ctx.card.dataset.productTitle || '';
      if (modalBadge) {
        modalBadge.textContent = (ctx.mode === 'add-cart')
          ? (ctx.qty + ' × ' + (parseInt(ctx.card.dataset.bundleSize, 10) || 10) + '+1')
          : 'Bundle';
      }

      // populate variants
      if (modalVars) {
        modalVars.innerHTML = '';
        var selectedId = null;
        ctx.variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kbo-modal__variant';
          btn.textContent = v.title;
          btn.dataset.variantId = v.id;
          var enoughStock = (v.policy === 'continue') || (v.inv >= ctx.qty);
          if (!v.available || !enoughStock) {
            btn.classList.add('is-soldout');
            btn.disabled = true;
          }
          btn.addEventListener('click', function () {
            modalVars.querySelectorAll('.kbo-modal__variant').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
            selectedId = parseInt(btn.dataset.variantId, 10);
            if (modalConfirm) modalConfirm.disabled = false;
          });
          modalVars.appendChild(btn);
        });

        // auto-select if there's only one selectable
        var selectable = modalVars.querySelectorAll('.kbo-modal__variant:not(:disabled)');
        if (selectable.length === 1) {
          selectable[0].click();
        }
      }

      // confirm button label
      if (modalConfirmLbl) {
        modalConfirmLbl.textContent = t('offer.modal.confirm_qty', { qty: ctx.qty });
      }
      if (modalConfirm) {
        modalConfirm.disabled = !modalVars.querySelector('.is-selected');
      }

      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      modalCtx = null;
      hideModalError();
      if (modalConfirm) modalConfirm.classList.remove('is-loading');
    }

    if (modal) {
      modal.querySelectorAll('[data-kbo-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
      });
    }

    if (modalConfirm) {
      modalConfirm.addEventListener('click', function () {
        if (!modalCtx) return;
        var selected = modalVars.querySelector('.kbo-modal__variant.is-selected');
        if (!selected) return;
        var variantId = parseInt(selected.dataset.variantId, 10);
        var variant = modalCtx.variants.filter(function (v) { return v.id === variantId; })[0];
        if (!variant) return;

        if (modalCtx.mode === 'add-cart') {
          modalConfirm.classList.add('is-loading');
          modalConfirm.disabled = true;
          submitViaCartHandler(
            [{ id: variantId, quantity: modalCtx.qty }],
            {
              onSuccess: function (cart) {
                document.dispatchEvent(new CustomEvent('kbo:add-success', { detail: cart }));
                closeModal();
              },
              onError: function () {
                showModalError(t('offer.error.add_failed'));
                modalConfirm.classList.remove('is-loading');
                modalConfirm.disabled = false;
              }
            }
          );
        } else {
          // add-bundle
          pushToBundle(buildBundleEntry(modalCtx.card, variant));
          closeModal();
        }
      });
    }

    function showModalError(msg) {
      if (!modalError) return;
      modalError.textContent = msg;
      modalError.removeAttribute('hidden');
    }
    function hideModalError() {
      if (!modalError) return;
      modalError.setAttribute('hidden', '');
      modalError.textContent = '';
    }

    // ----- persistence -----
    function loadBundle() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        var arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.slice(0, 6) : [];
      } catch (e) { return []; }
    }
    function saveBundle() {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(bundle)); } catch (e) {}
    }
    function clearBundle() {
      bundle.length = 0;
      saveBundle();
      renderTray();
    }

    // ----- initial render -----
    renderTray();
    updateTrayVisibility();
  }
})();
